import { DatePicker } from 'antd';
import moment, { Moment } from 'moment';
import React, { FC, useEffect, useState } from 'react';
import { FieldWithValue } from 'api/tasks';
import { humanise } from 'components/atoms/humanised-date';

interface Props {
  className?: string;
  initialValue?: number;
  field: FieldWithValue;
  onChange: (selected, field) => void;
}

export const DateField: FC<Props> = (props) => {
  const { className, initialValue, field, onChange } = props;
  const [value, setValue] = useState<number>();

  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleOnChange = (date: Moment | null) => {
    if (date != null) {
      const timestamp = date.endOf('day').valueOf();

      setValue(timestamp);
      onChange(timestamp, field);
    } else {
      setValue(undefined);
      onChange(date, field);
    }
  };

  return (
    <DatePicker
      placeholder="—"
      format={humanise}
      className={className}
      role="button"
      tabIndex={0}
      allowClear
      bordered={false}
      size="small"
      value={value ? moment(value) : undefined}
      onChange={handleOnChange}
    />
  );
};
